import { useAppSelector } from '../../../../../app/hooks';
import * as lodash from 'lodash';
import './print-select-images.tabs.scss';
import { useParams } from 'react-router-dom';
import { PathParams } from '../../../../../routes/routing-path';
import { useCallback, useMemo } from 'react';
import { PrintDataStructure } from '../../../../../models/sift/json/print-model';
import { Button } from '../../../../ui/button/button';
import { PrintSelectImageData } from '../hooks/use-print-select-images';
import { CiCirclePlus } from "react-icons/ci";

type Props = {
  structure: PrintDataStructure,
  images: PrintSelectImageData[],
  selectId: string,
  theme: string,
  handlerChangeSize: () => void,
  onAddOrder: () => void,
  onSelect: (id: string) => void,
  onDelete: (id: string) => void,
  onReturn: () => void,
}

export const PrintSelectImagesTabs = (props: Props) => {
  const {
    structure,
    selectId,
    onSelect,
    images,
    theme,
    handlerChangeSize,
    onReturn,
    onDelete,
    onAddOrder,
  } = props;
  const { shopOrderId } = useParams<PathParams>();
  const list = useMemo(() => {
    return structure?.getItemList() ?? [];
  }, [structure]);

  const imageCount = useCallback((id: string) => {
    if (selectId === id) {
      return images.reduce((a, b) => a + (b.count ?? 0), 0);
    } else {
      return structure.item?.[id]?.images?.reduce((a, b) => a + (b.count ?? 0), 0) ?? 0;
    }
  }, [images, structure, selectId]);

  const classNameExt = useCallback((id: string) => {
    const result: string[] = [];
    if (id === selectId) {
      result.push('is_select');
    }
    return result.join(' ');
  }, [selectId]);
  const dummy = () => list.filter((v) => v.id !== selectId);

  return (
    <div className="print_select_images__tabs_wrap">
      <div className="print_select_images__tabs__left">
        <div className={`print_select_images__tabs ${theme}`}>
          {/* {[...list, ...dummy(), ...dummy(), ...dummy(), ...dummy(), ...dummy(), ...dummy(), ...dummy()].map((info) => ( */}
          {list.map((info) => (
            <div
              key={info.id}
              className={`print_select_images__tabs__tab ${classNameExt(info.id)}`}
              onClick={() => onSelect(info.id)}
              title={info.productData?.ProductDetailItemData?.itemName ?? ''}
            >
              <div className="circle_num">
                {imageCount(info.id)}
              </div>
              <div className="tab_label">
                {info.productData?.ProductDetailItemData?.itemName ?? ''}
              </div>
                <div className="button_box">
                {!!(selectId === info.id) && (
                  <Button
                    icon={<CiCirclePlus fill="#fff" size="14px" strokeWidth="2px" />}
                    label="サイズ追加"
                    className="size_plus"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handlerChangeSize();
                    }}
                  />
                )}
                {!!(list.length > 1) && (
                  <button
                    className="delete_btn"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onDelete(info.id);
                    }}
                  >
                    &times;
                  </button>
                )}
                </div>
            </div>
          ))}
          {/* <div className="print_select_images__tabs__tab">
            test
          </div>
          <div className="print_select_images__tabs__tab is_select">
            test
          </div> */}
        </div>
        <Button
          label="商品追加"
          className="add_order_btn"
          icon={<CiCirclePlus fill="#fff" size="16px" strokeWidth="2px" />}
          onClick={onAddOrder}
        />
      </div>
      <div className="print_select_images__tabs__right">
        <Button
          label="戻る"
          color="danger"
          className="btn_back"
          onClick={() => onReturn()}
        />
      </div>
    </div>
  )
}
